// extracted by mini-css-extract-plugin
export default {"container":"rating_container__aSGCS","count":"rating_count__lLoFd","icon":"rating_icon__bcrhY"};